import type { ChartResponse } from "../api/types";
import { formatCurrency } from "../lib/format";
import { SignalPill } from "./SignalPill";

interface QuoteHeaderProps {
  companyName: string;
  symbol: string;
  chart: ChartResponse | null;
  signal?: string | null;
}

export function QuoteHeader({ companyName, symbol, chart, signal }: QuoteHeaderProps) {
  const summary = chart?.summary;
  const hasQuote = Boolean(summary && summary.last_close !== null);

  let priceText = "--";
  let changeText = "--";
  let changeClass = "price-change";

  if (hasQuote && summary && chart) {
    const change = Number(summary.period_change || 0);
    const changePercent = summary.period_change_percent;
    priceText = formatCurrency(summary.last_close, chart.currency);

    const sign = change > 0 ? "+" : "";
    const percentText =
      changePercent === null || changePercent === undefined
        ? ""
        : ` (${sign}${Number(changePercent).toFixed(2)}%)`;
    changeText = `${sign}${formatCurrency(change, chart.currency)}${percentText} ${chart.range}`;
    if (change > 0) {
      changeClass += " price-up";
    } else if (change < 0) {
      changeClass += " price-down";
    }
  }

  return (
    <div className="quote-header">
      <div className="quote-id">
        <p className="company-name">{companyName}</p>
        <div className="quote-title">
          <h1>{symbol || "--"}</h1>
          {signal ? <SignalPill signal={signal} /> : null}
        </div>
      </div>
      <div className="quote-price-block">
        <span className="last-price">{priceText}</span>
        <span className={changeClass}>{changeText}</span>
      </div>
    </div>
  );
}
